const frontendVersion = ((import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev").trim() || "dev";
const frontendBuild = ((import.meta.env.VITE_APP_BUILD as string | undefined) ?? "dev").trim() || "dev";

export const frontendBuildInfo = {
    version: frontendVersion,
    build: frontendBuild,
};

export function backendVersionDiffersFromFrontend(health: { version?: string | null; build?: string | null }) {
    const backendVersion = (health.version ?? "").trim();
    const backendBuild = (health.build ?? "").trim();
    const versionDiffers = backendVersion.length > 0 && backendVersion !== frontendBuildInfo.version;
    const buildDiffers = frontendBuildInfo.build !== "dev" && backendBuild.length > 0 && backendBuild !== frontendBuildInfo.build;
    return versionDiffers || buildDiffers;
}
